import { Routes, Route, Navigate, Link, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { logout } from '../lib/auth'
import { LayoutDashboard, Users, CreditCard, Monitor, Settings, Plane, LogOut, ChevronRight, ArrowLeftRight } from 'lucide-react'
import AdminDashboard from './Admin/Dashboard'
import AdminPlans from './Admin/Plans'
import AdminCustomers from './Admin/Customers'
import AdminDisplays from './Admin/Displays'
import AdminSettings from './Admin/Settings'

const navItems = [
  { path: '/admin', label: 'Dashboard', icon: <LayoutDashboard className="w-4 h-4" /> },
  { path: '/admin/plans', label: 'Plans', icon: <CreditCard className="w-4 h-4" /> },
  { path: '/admin/customers', label: 'Customers', icon: <Users className="w-4 h-4" /> },
  { path: '/admin/displays', label: 'Displays', icon: <Monitor className="w-4 h-4" /> },
  { path: '/admin/settings', label: 'Settings', icon: <Settings className="w-4 h-4" /> },
]

export default function Admin() {
  const { user, loading, isAdmin } = useAuth()
  const location = useLocation()

  if (loading) return <div className="min-h-screen bg-slate-950 flex items-center justify-center"><div className="w-8 h-8 border-2 border-flight-cyan border-t-transparent rounded-full animate-spin" /></div>
  if (!user) return <Navigate to="/login" replace />
  if (!isAdmin) return <Navigate to="/" replace />
  
  return (
    <div className="min-h-screen bg-slate-950 flex">
      <aside className="w-64 bg-slate-900 border-r border-slate-800 flex flex-col">
        <div className="p-4 border-b border-slate-800">
          <Link to="/" className="flex items-center gap-2">
            <Plane className="w-5 h-5 text-flight-cyan" />
            <span className="text-lg font-bold text-white">FlightWall</span>
          </Link>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {navItems.map(item => (
            <Link key={item.path} to={item.path} className={`admin-sidebar-link ${location.pathname === item.path ? 'active' : ''}`}>
              {item.icon}<span>{item.label}</span>{location.pathname === item.path && <ChevronRight className="w-3 h-3 ml-auto" />}
            </Link>
          ))}
          <Link to="/dashboard" className="admin-sidebar-link mt-4 pt-4 border-t border-slate-800">
            <ArrowLeftRight className="w-4 h-4" /><span>My Displays</span>
          </Link>
        </nav>
        <div className="p-4 border-t border-slate-800">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-8 h-8 rounded-full bg-flight-cyan/20 flex items-center justify-center text-flight-cyan text-xs font-bold">{user.email?.charAt(0).toUpperCase()}</div>
            <div className="flex-1 min-w-0">
              <div className="text-white text-sm truncate">{user.email}</div>
              <div className="text-slate-500 text-xs capitalize">{user.role}</div>
            </div>
          </div>
          <button onClick={logout} className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-slate-400 hover:text-white hover:bg-slate-800 transition-colors text-sm">
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <Routes>
          <Route path="/" element={<AdminDashboard />} />
          <Route path="/plans" element={<AdminPlans />} />
          <Route path="/customers" element={<AdminCustomers />} />
          <Route path="/displays" element={<AdminDisplays />} />
          <Route path="/settings" element={<AdminSettings />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </main>
    </div>
  )
}
